import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import { toast } from 'react-toastify';
import LoginInput from '../components/login-input';

function Login() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const login = () => {
        if (loading)
            return;
        var err = [];
        if (userName === '')
            err.push('Username is required.');
        if (password === '')
            err.push('Password is required.');
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'login', {
                username: userName,
                password: password,
                rememberMe: rememberMe ? 1 : 0
            }).then((r) => {
                    setLoading(false);
                    if (r?.data?.token) {
                        localStorage.setItem('jwt', r.data.token);
                        setTimeout(() => navigate(r.data.to), 1750);
                        toast.success('Logged in successfully.');
                    }
                }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    return (
        <div className="container-center">
            <div className="container login-container">
                <div className="form">
                    <div className="content-box">
                        <div className="content-body" style={{padding: 25}}>
                            <div className="w-100 a-center f-end f-row f-wrap" style={{gap: 25}}>
                                <img src="/podcast-premium-logo.png" width="132" height="40" style={{marginRight: 'auto'}} alt="Podcast Premium Logo" />
                                <h1>Login</h1>
                                <LoginInput label="E-mail address" value={userName} type="text" onChange={(e) => { setUserName(e.target.value) }} />
                                <LoginInput label="Password" value={password} type="password" onChange={(e) => { setPassword(e.target.value) }} />
                                <div className="flex w-100 f-between f-row">
                                    <label>
                                        <input type="checkbox" onChange={(e) => { setRememberMe(e.target.checked) }} />
                                        Remember me
                                    </label>
                                    <Link className="forgot-password-link" to="/login">Forgot Password?</Link>
                                </div>
                                <div className="w-100 f-row f-end gap-10">
                                    <button className="btn" onClick={login}>
                                        {loading ? (
                                            <div className="loading f-row">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        ) : <>Login</>
                                        }
                                    </button>
                                </div>
                                <div className="w-100 sign-up">
                                    Dont have an acount?
                                    <Link className="sign-up-link" to="/join">
                                        Sign up
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;